import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import {
  Bundle,
  DocumentReference,
} from 'src/careflow/ph-core/fhir-client/resources';

export async function getDocuments(patientId: string) {
  const data = await apiClient.get<Bundle<DocumentReference[]>>(
    `crs/document/patient/${patientId}`
  );
  return data;
}

export async function getBinaryDocument(
  patient: string,
  documentUniqueId: string,
  repositoryUniqueId: string,
  hcid: string
) {
  const data = await apiClient.get<DocumentReference>(
    `crs/document/${patient}?documentId=${documentUniqueId}&repositoryId=${repositoryUniqueId}&hcid=${hcid}`
  );
  return data;
}
